import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'error-forbidden',
  templateUrl: './forbidden.component.html'
})
export class ForbiddenComponent implements OnInit {

  @Input() public title?: string;
  @Input() public description?: string;

  constructor() { }

  ngOnInit(): void {
  }

}
